// Pure helpers for the notification feature. No React, no network — safe to
// unit test directly and to reuse from the provider.

export const SEEN_IDS_CAP = 500;

export function createSeenIdsState() {
  return { set: new Set(), order: [] };
}

/** Adds `id` to the seen-set, evicting the oldest entry once the cap is hit. */
export function markSeenOne(state, id) {
  if (id == null || state.set.has(id)) return state;
  state.set.add(id);
  state.order.push(id);
  if (state.order.length > SEEN_IDS_CAP) {
    const oldest = state.order.shift();
    state.set.delete(oldest);
  }
  return state;
}

export function markSeenMany(state, ids) {
  (ids || []).forEach(id => markSeenOne(state, id));
  return state;
}

export function hasSeen(state, id) {
  return state.set.has(id);
}

/** Filters `tickets` to those not already in `state`, keyed by `idKey`. */
export function partitionUnseen(tickets, state, idKey = 'id') {
  return (tickets || []).filter(ticket => !hasSeen(state, ticket[idKey]));
}
